import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ROUTES } from 'constants.js';
import { EmptyIcon } from 'components/Shared/Icons';
import { getCurrencySymbol } from 'utils/currencyUtil';
import useTranslation from 'utils/hooks/useTranslation';

import styles from './style.module.scss';

const BalanceHistory = () => {
  const { translateText } = useTranslation();
  const { currentCorporation } = useSelector(state => state.user);
  const symbol = getCurrencySymbol(currentCorporation?.country);

  return (
    <div className={styles.history} data-testid="walletBalanceHistory">
      <h3 className={styles.historyTitle}>
        {translateText('corporateAccounts.wallet.dashboard.history.title')}
      </h3>
      <p className={styles.historyDescription}>
        {translateText('corporateAccounts.wallet.dashboard.history.description')}{' '}
        <Link
          to={ROUTES.REPORTS}
          className={styles.link}
          data-testid="walletBalanceHistoryReportsLink"
        >
          {translateText('corporateAccounts.reports.main.title')}
        </Link>
        .
      </p>
      <div className={styles.historyTableHeader}>
        <span>{translateText('corporateAccounts.wallet.dashboard.history.date')}</span>
        <span>{translateText('corporateAccounts.wallet.dashboard.history.type')}</span>
        <span>
          {translateText('corporateAccounts.wallet.dashboard.history.amount', { symbol })}
        </span>
        <span>
          {translateText('corporateAccounts.wallet.dashboard.history.balance', { symbol })}
        </span>
        <span className={styles.historyStatusCol}>
          {translateText('corporateAccounts.wallet.dashboard.history.status')}
        </span>
      </div>
      <div className={styles.historyEmpty} data-testid="walletBalanceHistoryEmpty">
        <div className={styles.historyEmptyIcon}>
          <EmptyIcon />
        </div>
        <div className={styles.historyEmptyCopy}>
          {translateText('corporateAccounts.wallet.dashboard.history.emptyCopy')}
        </div>
      </div>
    </div>
  );
};

export default BalanceHistory;
